import type { QueryClient } from '@tanstack/react-query'

/** Lets non-React helpers reach the app's QueryClient (set once in main.tsx). */
export const queryClientRef: { current: QueryClient | null } = { current: null }
